export const recertifyOrEndEnrollmentStrings = {
  strings: {
    en: {
      recertifyOrEndEnroll: 'Recertify or End Enrollment',
      recertifyOrEndEnrollDiscription: 'Our records indicate you have previously enrolled. Please select what you like to do.',
      recertify: 'Recertify',
      endEnrollment: 'End Enrollment',
      recertifyHint: 'Choose this option if you would like to renew your enrollment in the CARE / FERA program.',
      endEnrollmentHint: 'Choose this option if your household no longer qualifies for CARE or FERA',
      errorMessage: 'Please choose any of the options to verify and proceed',
    },
    es: {
      recertifyOrEndEnroll: 'Recertificar o terminar la inscripción',
      recertifyOrEndEnrollDiscription: 'Nuestros registros indican que se ha inscrito previamente. Por favor selecciona lo que te gustaría hacer',
      recertify: 'Recertificar',
      endEnrollment: 'Inscripción final',
      recertifyHint: 'Elija esta opción si desea renovar su inscripción en el programa CARE/FERA.',
      endEnrollmentHint: 'Elija esta opción si su hogar ya no califica para CARE o FERA.',
      errorMessage: 'Por favor elige cualquiera de las opciones para verificar y proceder.',
    },
    zh: {
      recertifyOrEndEnroll: '重新认证或结束注册',
      recertifyOrEndEnrollDiscription: '我们的记录显示您之前已注册。 请选择您想要做的事情。',
      recertify: '重新认证',
      endEnrollment: '结束注册',
      recertifyHint: '如果您想续订CARE / FERA 计划中的注册，请选择此选项。',
      endEnrollmentHint: '如果您的家庭不再符合CARE或FERA的资格，请选择此选项.',
      errorMessage: '请选择任何选项进行验证并继续',
    },
    ko: {
      recertifyOrEndEnroll: '재 등록 또는 등록 종료',
      recertifyOrEndEnrollDiscription: '저희 기록은 귀하가 이전에 등록했음을 나타냅니다. 원하는 것을 선택하십시오.',
      recertify: '재 인증',
      endEnrollment: '최종 등록',
      recertifyHint: 'CARE / FERA 프로그램에 등록을 갱신하려면이 옵션을 선택하십시오.',
      endEnrollmentHint: '가족이 CARE 또는 FERA 자격이없는 경우이 옵션을 선택하십시오.',
      errorMessage: '확인하고 진행할 옵션을 선택하십시오.',
    },
    vi: {
      recertifyOrEndEnroll: 'Xác nhận lại hoặc kết thúc đăng ký',
      recertifyOrEndEnrollDiscription: 'Hồ sơ của chúng tôi cho thấy bạn đã đăng ký trước đó. Vui lòng chọn những gì bạn muốn làm.',
      recertify: 'Xác nhận lại',
      endEnrollment: 'Kết thúc đăng ký',
      recertifyHint: 'Chọn tùy chọn này nếu bạn muốn gia hạn đăng ký của mình trong chương trình CARE / FERA.',
      endEnrollmentHint: 'Chọn tùy chọn này nếu hộ gia đình của bạn không còn đủ điều kiện tham gia CARE hoặc FERA nữa.',
      errorMessage: 'Vui lòng chọn bất kỳ tùy chọn nào để xác minh và tiếp tục.',
    }

  },
  common: []
};